import React from "react";
import TipsyButton from '../../common/TipsyButton';
import {
  TipsBody,
  TipsButtonPanel,
  TipsGrouping,
  TipsHeader,
  TipsActionButton,
  TipsPageWrapper
} from './Atoms';
import TipsyInput from "../../common/TipsyInput";
import {Tip} from "../../../model/dtos/Tip";
import {color2,color3} from '../../../constants/color';

type EditableTip={
  id : number;
  to : string;
  amount : string;
}

type TipsPageProps={
  tips: Tip[]
  onClose : ()=>void
  onAccept:(tips:Tip[])=>void
}
type TipsPageState={
  tips: EditableTip[]
}

class TipsPage extends React.Component<TipsPageProps,TipsPageState> {
  constructor(props: TipsPageProps) {
    super(props);
    this.state = {
      tips:[...this.props.tips.map(this.toEditableTip)],
    };
  }

  private toEditableTip(tip:Tip):EditableTip {
    return {...tip,amount:tip.amount.toString()};
  }
  private toTip(editableTip:EditableTip):Tip {
    return {...editableTip,amount:Number(editableTip.amount)};
  }

  handleDelete (id){
    this.setState({tips:this.state.tips.filter(tip=>tip.id !== id)});
  }

  addTip(){
    const newId = this.state.tips.reduce((max,current)=>current.id>max?current.id:max,0)+1;
    this.setState({tips:[...this.state.tips,{id:newId,to:'',amount:'0'}]});
  }

  numericFieldIsValid (fieldValue : string):boolean {
    return /^[\d]+[.]*[\d]{0,2}$/.test(fieldValue);
  }

  editAmount(id:number,technician:string,e: React.FormEvent<HTMLInputElement>){
    const newAmount = e.currentTarget.value;
    if(newAmount === '' || this.numericFieldIsValid(newAmount)){
      this.setState({tips:[...this.state.tips.filter(tip=>tip.id !== id),{id:id,to:technician,amount:newAmount}]});
    }
  }

  editRecipient(id,amount,e: React.FormEvent<HTMLInputElement>){
      const newRicipient = e.currentTarget.value;
      this.setState({tips:[...this.state.tips.filter(tip=>tip.id !== id),{id:id,to:newRicipient,amount:amount}].sort((a,b)=>a.id-b.id)});
  }

  maxTipEnetries():boolean{
    return this.state.tips.length>=3;
  }


  private isPageValid() {
    return this.state.tips.filter(tip=>tip.to.length <2 || Number(tip.amount) <= 0).length==0;
  }

  private tipsAreEqual(t1:EditableTip,t2:EditableTip):boolean{
    return Object.keys(t1).length === Object.keys(t2).length
    && Object.keys(t1).every(k => t1[k] === t2[k]);
  }

  private isPageDirty(){
    if(this.state.tips.length !== this.props.tips.length){
      return true;
    }
    let dirty = false;
    for (let i = 0; i < this.state.tips.length; i++) {
      dirty = dirty || !this.tipsAreEqual(this.state.tips[i],this.props.tips.map(this.toEditableTip)[i]);
    }
    return dirty;
  }

  private save(){
    this.props.onAccept(this.state.tips.map(this.toTip));
  }

  renderTips() {
    return this.state.tips.map((tip) => {
      const techId = "test"+tip.id;
      const amountId = "amount"+tip.id;
      return (<TipsGrouping key={tip.id}>
        <label>To:</label>
        <TipsyInput testid={techId} value={tip.to} onChange={e=>this.editRecipient(tip.id,tip.amount,e)}/>
        <TipsActionButton data-testid="delete-group" style={{color:'red'}} onClick={()=>this.handleDelete(tip.id)}>X</TipsActionButton>
        <label>Amount:</label>
        <TipsyInput testid={amountId} value={tip.amount.toString()} onChange={e=>this.editAmount(tip.id,tip.to,e)}/>

      </TipsGrouping>);
    });
  }

  render() {
    const maxEntries = this.maxTipEnetries();
    const canSave = this.isPageValid() && this.isPageDirty();
    return (
      <TipsPageWrapper>
        <TipsHeader>Tips</TipsHeader>
        <TipsBody>
          {this.renderTips()}
        </TipsBody>
        <TipsButtonPanel>
          <TipsyButton id="add-tip-button" testid="add-tip-button" text="Add Tip" color={color3} onClick={() =>this.addTip()} disabled={maxEntries} />
          <TipsyButton id="save-tips-button" testid="save-tips-button" text="Save Tips" color={color2} onClick={() =>this.save()} disabled={!canSave} />
          <TipsyButton id="close-button" text="Close" color="red" onClick={this.props.onClose}/>
        </TipsButtonPanel>
      </TipsPageWrapper>
    );
  }

}

export default TipsPage;
